export const EVENT_CATEGORY = 'ReservationModule';
